import { useEffect, useState } from 'react';
import searchService from '../../api/searchService';
import { useFilters } from '../../context/FilterContext';
import { SORT_OPTIONS } from '../../utils/constants';

export default function AdvancedFilters() {
  const { filters, update, reset } = useFilters();
  const [types, setTypes] = useState([]);

  useEffect(() => {
    searchService.technicianTypes().then(setTypes).catch(() => {});
  }, []);

  return (
    <aside className="card pad stack" style={{ gap: '.25rem' }}>
      <div className="spread">
        <strong>Filters</strong>
        <button className="btn ghost sm" onClick={reset}>Reset</button>
      </div>

      <div className="field">
        <label>Keyword</label>
        <input
          value={filters.keyword}
          onChange={(e) => update({ keyword: e.target.value })}
          placeholder="name, trade, bio…"
        />
      </div>

      <div className="field">
        <label>Trade</label>
        <select value={filters.technicianTypeId} onChange={(e) => update({ technicianTypeId: e.target.value })}>
          <option value="">Any</option>
          {types.map((t) => <option key={t.id} value={t.id}>{t.name}</option>)}
        </select>
      </div>

      <div className="field"><label>City</label>
        <input value={filters.city} onChange={(e) => update({ city: e.target.value })} />
      </div>
      <div className="field"><label>State / region</label>
        <input value={filters.state} onChange={(e) => update({ state: e.target.value })} />
      </div>
      <div className="field"><label>Max hourly rate</label>
        <input type="number" min="0" value={filters.maxHourlyRate} onChange={(e) => update({ maxHourlyRate: e.target.value })} />
      </div>
      <div className="field"><label>Minimum rating</label>
        <select value={filters.minRating} onChange={(e) => update({ minRating: e.target.value })}>
          <option value="">Any</option>
          <option value="3">3+</option>
          <option value="4">4+</option>
          <option value="4.5">4.5+</option>
        </select>
      </div>
      <div className="field"><label>Sort by</label>
        <select value={filters.sortBy} onChange={(e) => update({ sortBy: e.target.value })}>
          {SORT_OPTIONS.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
        </select>
      </div>
      <label style={{ display: 'flex', gap: '.5rem', alignItems: 'center', fontSize: '.9rem' }}>
        <input
          type="checkbox"
          checked={filters.availableOnly}
          onChange={(e) => update({ availableOnly: e.target.checked })}
        />
        Available only
      </label>
    </aside>
  );
}
